function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import SelectApplication from '../../common/form/select/SelectApplication.react';
import SelectPage from '../../common/form/select/SelectPage.react';
import SelectArticleType from '../../common/form/select/SelectArticleType.react';
import Textarea from '../../common/form/Textarea.react';
import Label from '../../common/form/Label.react';
import Button from '../../common/Button.react';
var ArticlesAdd = function ArticlesAdd(_ref) {
  var _ref$app = _ref.app,
    pApp = _ref$app === void 0 ? '' : _ref$app,
    _ref$pageID = _ref.pageID,
    pPageID = _ref$pageID === void 0 ? '' : _ref$pageID,
    articlesAction = _ref.articlesAction,
    _ref$articleType = _ref.articleType,
    pArticleType = _ref$articleType === void 0 ? '' : _ref$articleType;
  var _useState = useState({
      app: pApp,
      pageID: pPageID,
      articleType: pArticleType,
      title: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var app = state.app,
    pageID = state.pageID,
    title = state.title,
    articleType = state.articleType;
  var isValid = function isValid() {
    return app.length > 0 && pageID.length > 0 && articleType.length > 0 && title.length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Article"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Application",
    required: true
  }), /*#__PURE__*/React.createElement(SelectApplication, {
    value: app,
    excludeArr: ['cms'],
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        app: sValue
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Page",
    required: true
  }), /*#__PURE__*/React.createElement(SelectPage, {
    value: pageID,
    app: app,
    pageType: "article-page",
    onChange: function onChange(option) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        pageID: option._id
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Article Type",
    required: true
  }), /*#__PURE__*/React.createElement(SelectArticleType, {
    value: articleType,
    app: app,
    pageType: "article-page",
    onChange: function onChange(_ref3) {
      var sValue = _ref3.sValue;
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        articleType: sValue
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true
  }), /*#__PURE__*/React.createElement(Textarea, {
    value: title,
    style: {
      height: 100
    },
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      articlesAction({
        formData: {
          app: app,
          pageID: pageID,
          articleType: articleType,
          title: title
        },
        method: 'post'
      });
    },
    label: "Add",
    disabled: !isValid()
  })));
};
var mdtp = {
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(ArticlesAdd);